/**
 * PrimeStaking psXDC V3 vault — withdrawal global-queue read surface
 * (XDC mainnet, chainId 50). Vault
 * `0x98D916F5773Ac0482b49856f2659d6c32114C4Ba`.
 *
 * `redeemWithQueue` mints a GLOBAL `requestId` (there is no
 * `getUserWithdrawals(address)` getter), so enumeration scans
 * `withdrawalRequests(requestId)` and filters by the `receiver` field —
 * the same shape as Infrared's iBERA WithdraworLite queue. Each request
 * carries a `processed` flag (true once the masternode payout has
 * settled it and the assets are claimable via `claimQueuedAssets`);
 * `nextWithdrawalRequestId` is the exclusive upper bound of assigned ids
 * and `nextUnprocessedWithdrawalRequestId` is the FIFO finalisation
 * frontier (ids below it are processed).
 */
export const PrimeStakingQueueAbi = [
  {
    name: 'withdrawalRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'requestId', type: 'uint256' }],
    outputs: [
      { name: 'owner', type: 'address' },
      { name: 'receiver', type: 'address' },
      { name: 'shares', type: 'uint256' },
      { name: 'assets', type: 'uint256' },
      { name: 'processed', type: 'bool' },
    ],
  },
  {
    name: 'nextWithdrawalRequestId',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'nextUnprocessedWithdrawalRequestId',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
